import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {PATTERNS} from '../../../common/constants';
import {Tenure} from '../../../common/models/tenure-model';
import {FormerTenureValidity} from '../../../common/models/former-tenure-validity.model';
import {ParentPlanType} from '../../../common/models/parent-plan-type.model';
import {SubjectLandType} from '../../../common/models/subject-land-type.model';
import {TenureService} from '../tenure.service';
import {NgClass} from '@angular/common';
import {ControlContainer, FormsModule, NgForm} from '@angular/forms';
import {NlrHasPermissionsPipe} from '../../../common/pipe/nlr-has-permissions.pipe';
import {NlrPermissionsDisabledPipe} from '../../../common/pipe/nlr-permissions-disabled-pipe';
import {NlrPatternDirective} from '../../../common/directive/nlr-pattern.directive';
import {NlrFormFieldHasErrorPipe} from '../../../common/pipe/nlr-form-field-has-error.pipe';
import {NgSelectModule} from '@ng-select/ng-select';

@Component({
    selector: 'nlr-tenure-subject-land',
    imports: [NgClass, FormsModule, NlrHasPermissionsPipe, NlrPermissionsDisabledPipe, NlrPatternDirective, NlrFormFieldHasErrorPipe, NgSelectModule],
    templateUrl: './tenure-subject-land.component.html',
    styleUrl: './tenure-subject-land.component.scss',
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class TenureSubjectLandComponent implements OnChanges {
    @Input() tenure: Tenure;
    @Input() formerTenureValidityLookup: FormerTenureValidity;
    @Input() parentPlanTypeLookups: ParentPlanType[];
    @Input() subjectLandTypeLookups: SubjectLandType[];
    @Input() titleReferenceLabel: string;
    @Input() label: string;
    @Input() submitted: boolean;
    @Input() readonly: boolean;
    @Input() name!: string;

    constructor(private tenureService: TenureService) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['tenure']) {
            this.internalSubjectLandTypeLookups.splice(
                0,
                this.internalSubjectLandTypeLookups.length,
                ...structuredClone(this.subjectLandTypeLookups)
            );
        }
    }

    subjectLandDescriptionMaxLength = 100;

    titlePattern = PATTERNS.TITLE_PATTERN;

    internalSubjectLandTypeLookups = [];

    showSubjectLandDescription() {
        return ['Optional', 'Mandatory'].indexOf(this.getDisplaySubjectLand()) !== -1;
    }

    showTitle() {
        return ['Optional', 'Mandatory'].indexOf(this.getDisplayTitleReference()) !== -1;
    }

    titleIsRequired() {
        return this.getDisplayTitleReference() === 'Mandatory';
    }

    subjectLandDescriptionIsRequired() {
        return this.getDisplaySubjectLand() === 'Mandatory';
    }

    getSubjectLandDescriptionCharactersRemaining() {
        if (!this.tenure.subjectLandDescription) {
            return this.subjectLandDescriptionMaxLength;
        }
        const newLineCount = this.tenure.subjectLandDescription.split('\n').length - 1;
        const characterCount = this.tenure.subjectLandDescription.length - newLineCount;
        return this.subjectLandDescriptionMaxLength - characterCount;
    }

    titleVerified() {
        const titleResponse = this.tenureService.getTitleResponse(this.tenure.title);
        return titleResponse && titleResponse.title;
    }

    titleVerifyError() {
        const titleResponse = this.tenureService.getTitleResponse(this.tenure.title);
        if (titleResponse) {
            return titleResponse.error;
        }
    }

    isTitleDuplicated() {
        return this.tenureService.isTitleDuplicated(this.tenure.title);
    }

    getDisplaySubjectLand() {
        if (this.tenure.subjectLandType) {
            const selectedSubjectLandType = this.subjectLandTypeLookups.filter(v => v.id === this.tenure.subjectLandType.id)[0];
            return selectedSubjectLandType ? selectedSubjectLandType.subjectLandDescription : undefined;
        }
        return undefined;
    }

    getDisplayTitleReference() {
        return this.formerTenureValidityLookup.subjectLandTitleReference;
    }

    subjectLandTypeOptionChange(subjectLandTypeOption: SubjectLandType) {
        this.tenure.subjectLandType = subjectLandTypeOption;
    }
}
